// ── Shared ECharts theme configuration ──────────────────────────────────────
// Central home for chart colours, tooltip styles, grid margins, and animation.
// All chart components should import from here instead of hardcoding theme values.

const THEMES = {
  light: {
    axisLabelColor: '#9ca3af',
    gridLineColor:  '#e5e7eb',
    tooltipBg:      '#ffffff',
    tooltipBorder:  '#e2e8f0',
    textColor:      '#374151',
  },
  dark: {
    axisLabelColor: '#627B99',
    gridLineColor:  'rgba(255,255,255,0.07)',
    tooltipBg:      '#1C2A3E',
    tooltipBorder:  'rgba(255,255,255,0.10)',
    textColor:      '#e2e8f0',
  },
};

/**
 * Get resolved chart theme colours for the current app theme.
 * @param {"light"|"dark"} theme
 * @returns {{ axisLabelColor: string, gridLineColor: string, tooltipBg: string, tooltipBorder: string, textColor: string }}
 */
export function getChartTheme(theme) {
  return THEMES[theme] ?? THEMES.light;
}

/**
 * Get a pre-built ECharts tooltip configuration for the given theme.
 * @param {"light"|"dark"} theme
 * @returns {object} ECharts tooltip option
 */
export function getChartTooltip(theme) {
  const t = getChartTheme(theme);
  return {
    backgroundColor: t.tooltipBg,
    borderColor: t.tooltipBorder,
    textStyle: { color: t.textColor, fontSize: 12 },
  };
}

/** Default chart grid margins. */
export const CHART_GRID = { top: 12, right: 12, bottom: 32, left: 48 };

/** Default chart animation config. */
export const CHART_ANIMATION = {
  animation: true,
  animationDuration: 480,
  animationEasing: 'cubicOut',
};

/** Standard series color palette. */
export const CHART_PALETTE = [
  '#0ea5e9', '#10b981', '#f59e0b', '#ef4444',
  '#8b5cf6', '#f97316', '#06b6d4', '#ec4899',
];
